module.exports = __webpack_public_path__ + "static/media/record-list-icon.32cccb66.svg";